<template>
	<div class="card mb-4">
		<div class="card-body">

			<h3 class="mb-4">Feedback</h3>

			<div v-if="isLoading" class="text-center p-5">
				<div class="spinner-border text-secondary" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
			</div>
			<div v-else>

				<div v-if="comments.length">
					<div v-for="comment in comments" :key="comment.id" class="mb-3">
						<div class="row">
							<div class="col-auto">
								<avatar :model="comment.commenter" size="sm"/>
							</div>
							<div class="col ms-n2">
								<div class="comment-body w-100">
									<h4 class="mb-1">
										{{ comment.commenter.name }}
										<span class="fw-normal fs-5 text-muted ms-1">
											{{ formatDate(comment.created_at) }}
										</span>
									</h4>
									<div v-html="nl2br(linkify(comment.body))"></div>
									<div v-if="canDelete" class="mt-1">
										<a href="#" @click.prevent="deleteComment(comment)" class="text-muted small">
											<i class="fe fe-trash-2 me-1"></i>Delete
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<p class="text-muted mb-0">No feedback yet.</p>
				</div>

			</div>

			<!-- Divider -->
			<hr>

			<!-- Add Comment Form -->
			<div class="row">
				<div class="col-auto">
					<avatar :model="signedInUser" size="sm"/>
				</div>
				<div class="col ms-n2">
					<label class="visually-hidden">
						Leave feedback...
					</label>
					<textarea
						v-model="body"
						name="body"
						class="form-control form-control-flush"
						data-autosize
						rows="1"
						placeholder="Leave feedback..."></textarea>
				</div>
				<div class="col-auto">
					<button
						@click="addComment"
						:disabled="!body.trim()"
						class="btn btn-sm btn-white px-4 py-2 rounded-pill">
						Submit
					</button>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import autosize from 'autosize';
	import Avatar from '../Avatar.vue';
	import dayjs from 'dayjs';

	export default {

		props: ['endpoint', 'canDelete'],

		components: {
			'avatar': Avatar,
		},

		data() {
			return {
				comments: [],
				body: '',
				signedInUser: window.App.user,
				isLoading: true,
			};
		},

		mounted() {
			autosize(this.$el.querySelectorAll('[data-autosize]'));
			this.fetch();
		},

		methods: {

			formatDate(date) {
				return dayjs(date).format('MMM D, YYYY h:mma');
			},

			fetch() {
				this.isLoading = true;
				axios.get(this.endpoint)
					.then((response) => {
						this.comments = response.data;
						this.isLoading = false;
					})
					.catch((error) => {
						console.error(error);
					});
			},

			addComment() {
				if (!this.body.trim()) return;

				axios.post(this.endpoint, {
					body: this.body
				}).then(({data}) => {
					this.body = '';
					this.comments.push(data);

					// resize textarea
					var textareas = this.$el.querySelectorAll('[data-autosize]');
					textareas.forEach((textarea) => {
						textarea.style.height = '41px';
					});
				});
			},

			deleteComment(comment) {
				if (!confirm('Delete this note?')) return;

				axios.delete(this.endpoint + '/' + comment.id)
					.then(() => {
						this.comments = this.comments.filter(c => c.id !== comment.id);
					})
					.catch((error) => {
						console.error(error);
					});
			},

			nl2br(str, is_xhtml) {
				var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
				return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
			},

			linkify(text) {
				var urlRegex = /(https?:\/\/[^\s]+)/g;
				return text.replace(urlRegex, function(url) {
					return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
				});
			}

		}
	}
</script>
